module.exports = __webpack_public_path__ + "static/media/save-xlsx.90eccc66.svg";